module.exports = __webpack_public_path__ + "static/3-99b137402b6cce98a9006546a86e5956.jpeg";